import Overview from "../components/Overview";
import WebApp from "../components/WebApp";

const OverviewPage = () => {
  return (
    <WebApp>
      <Overview></Overview>
    </WebApp>
  );
};


export default OverviewPage;